export default __webpack_public_path__ + "static/media/supplierBottom.17a3fc99.gif";